module.exports = __webpack_public_path__ + "img/manual.a3892408.svg";